import { vars } from '@app/config'
import { getCookie } from '@app/services'
import { getActiveB2CCookieNames, getAuthMode } from '@app/utils'

export const getActiveAuthTokenFromCookies = () => {
  const { isBackOfficeTokenMode } = getAuthMode()
  const { accessTokenCookie } = getActiveB2CCookieNames()

  return isBackOfficeTokenMode
    ? getCookie(vars.b2b_access_token) || getCookie(accessTokenCookie)
    : getCookie(accessTokenCookie) || getCookie(vars.b2b_access_token)
}
